import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Header from 'components/Header';
import HeaderCheckout from 'components/Cart/Header';

const getHeader = (location) => {
    const {pathname} = location;
    let type = '';

    if(pathname.indexOf('/_secure/cart') === -1 && pathname.indexOf('/checkout') === -1 && pathname.indexOf('/login-page') === -1 && pathname.indexOf('/centro-ayuda') === -1 && (pathname.indexOf('/new-checkout') === -1)){
        type = 'general';
    } else if (pathname.indexOf('/new-checkout') !== -1){
        type = 'new-checkout';
    }

    return type;
}

const HeaderRouter = (props) => {
    const [headerType, setHeaderType] = useState(getHeader(props.location));

    useEffect(() => {
        setHeaderType(getHeader(props.location));
    }, [props.location]);

    return <>
        {headerType === 'general' && <Header/>}
        {headerType === 'new-checkout' && <HeaderCheckout/>}
    </>;
}

HeaderRouter.propTypes = {
    location: PropTypes.object
};

export default withRouter(HeaderRouter);
